import React from 'react';

const ModalConfirm = ({ callBackConfirmAction, addAtion }) => {
    // 심플 텍스트, 텍스트 카드 글자수 변경
    // addAction: 버튼 추가 or 아이탬 추가
    const confirmAction = e => {
        const action = e.target.dataset.action;
        callBackConfirmAction(action, addAtion);
    };

    return (
        <div className="dialog-confirm">
            <h4>응답 설정 변경</h4>
            <p>
                {addAtion === 'addBtn' ? '버튼을 추가할 경우' : '응답을 케로셀로 변경할 경우'}
                <br />
                최대 글자수가 {addAtion === 'addBtn' ? '400' : '128'}자로
                제한되고
                <br />
                {addAtion === 'addBtn' ? '400' : '128'}자 이상의 텍스트는
                삭제됩니다.
                <br />
                <br />
                <strong>설정을 변경하시겠습니까?</strong>
            </p>
            <div>
                <button
                    type="button"
                    onClick={confirmAction}
                    data-action="submit"
                >
                    확인
                </button>
                <button
                    type="button"
                    onClick={confirmAction}
                    data-action="cancel"
                >
                    취소
                </button>
            </div>
        </div>
    );
};

ModalConfirm.defaultProps = {
    // bla: 'test',
};

export default ModalConfirm;
